import React, { useContext } from "react";
import { Container, Card, Button } from "react-bootstrap";
import { ThemeContext } from "../context/ThemeContext";

const SignInContainer = ({ onSignIn }) => {
  const { theme } = useContext(ThemeContext);
  const isDark = theme === "dark";

  return (
    <Container
      className="d-flex justify-content-center align-items-center flex-column text-center"
      style={{ minHeight: "70vh" }}
    >
      <Card
        className={`p-4 shadow-lg border-0 ${
          isDark ? "bg-dark text-light" : "bg-light text-dark"
        }`}
        style={{
          maxWidth: "400px",
          width: "100%",
          borderRadius: "15px",
          transition: "all 0.3s ease",
        }}
      >
        <Card.Body>
          <h3 className="fw-bold mb-3">Welcome to iShare</h3>
          <p
            style={{
              color: isDark ? "#cccccc" : "#6c757d",
              transition: "color 0.3s ease",
            }}
          >
            Securely upload, store, and share your files with ease.
          </p>
          <Button
            variant={isDark ? "primary" : "dark"}
            className="fw-semibold mt-3 px-4"
            onClick={onSignIn}
          >
            Sign in
          </Button>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default SignInContainer;
